// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./asset/frot.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./asset/imgs/3.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}

body {
  overflow: visible !important;
}

.nav-link span:hover {
  color: #e3b251 !important;
  transition: all 0.3s ease;
}
a {
  text-decoration: none;
}
.mylogo {
  width: 200px !important;
  height: 100px !important;
  z-index: 1;
}
.submit-btn {
  font-family: inherit;
}
.submit-btn:hover {
  color: #666666 !important;
  transition: all 0.3s ease;
}
.form-group input::placeholder {
  color: #bcb9b9 !important;
}
.form-group textarea::placeholder {
  color: #cbc6c6 !important;
}
.logimg:hover {
  width: 245px !important;
  height: 135px !important;
  z-index: 999 !important;
}
.nav-link {
  font-size: 14px;
  text-transform: capitalize;
  transition: all 0.3s ease;
}
.logimg {
  width: 200px !important;
  height: 120px !important;
  transition: all 0.3s ease;
  z-index: 999 !important;
}
.carousel-indicators button {
  color: gold !important;
  background-color: linear-gradient(#bf953f, #fcf6ba) !important;
}
.navbar-nav {
  align-items: center;
  vertical-align: middle;
}

.nav-link {
  margin-left: 20px;
}

.homeimge {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 140vh;
  width: 100%;
  position: relative;
  padding-bottom: 60px;
}
.hometext {
  color: #fff;
  text-align: center;
  font-size: 3.75rem;
  font-weight: 700;
  animation-duration: 1000ms;
  top: 25%;
  position: relative;
}
.hometext2 {
  color: #fff;
  text-align: center;
  justify-content: center;
  font-size: 20px;
  width: 69%;
  margin: auto;
  margin-top: 760px;
  display: flex;
  flex-wrap: wrap;
  word-break: normal;
}
.svgimg {
  width: 80px;
  height: 80px;
  transition: all 0.3s ease-in-out;
}
.svgimg:hover {
  width: 100px;
  height: 86px;
}

.headtext {
  font-size: 1.5rem;
  font-weight: 700;
}
.cimages h1 {
  display: none;
}

.cimg {
  width: 50%;
  height: 40%;
  margin: auto;
  display: block;
  transition: all 0.3s ease;
}

.cimg:hover {
  width: 55%;
}

/* onhover imag h1 display: block;  */
.cimages h1 {
  display: none;
  color: #fff;
  font-size: 1.5rem;
  font-weight: 700;
  margin: auto;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 85%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.cimages:hover h1 {
  display: block;
}
.dimgtest p {
  padding-top: 170px;
}
.dimgtest img {
  padding-top: 100px;
}
li {
  list-style-type: none;
}
.headerlogo {
  width: 150px;
  height: 100px;
  transition: all 0.3s ease;
}
.headerlogo:hover {
  width: 180px;
  height: 120px;
}
.arobtn {
  color: black !important;
  font-size: 1.5rem;
  background: linear-gradient(#bf953f, #fcf6ba) !important;
  margin-top: 155px !important;
  width: 50px !important;
  height: 50px !important;
  border-radius: 50% !important;
  border: none !important;
}

.heroimgbox {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  width: 100%;
}
.heroimgbox p {
  font-family: "Oswald", sans-serif !important;
  display: flex;
  color: #fff;
  font-size: 1.5rem;
  font-weight: 700;
  margin: auto;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 250px;
}

.img-container .inner-box {
  display: none;
}
.inner-text {
  display: block;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  padding: 30px;
}

.img-container:hover .inner-box {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 1.2rem;
  background-color: rgba(0, 0, 0, 0.5);
}

.headtest {
  color: #fcf6ba;
  font-family: "Roboto Slab", serif;
  font-size: 3rem;
  line-height: 1.1;
  text-shadow: 2px 2px 8px rgba(128, 128, 128, 1);
  font-weight: 700;
  transition: all 1.25s ease;
}

.headtest:hover {
  color: #fff;
  font-size: 3.7rem;
  transition: all 0.3s ease;
}

.logimgphone {
  width: 100px !important;
  height: 80px !important;
  display: none;
}
.iconphone {
  display: none !important;
}
.logoicon {
  display: none !important;
}
.bottomtext {
  margin-top: 100px;
}
.phonemode1 {
  display: block;
}

.phonemode2 {
  display: none;
}
.footerheight {
  height: 400px;
}

.cursorwidth {
  width: 75%;
}
/* media query  */
@media (max-width: 1024px) {
  .socialicon {
    display: none !important;
  }

  .logimgphone {
    width: 100px !important;
    height: 80px !important;
    display: block;
  }
  .logoicon {
    display: block !important;
  }
  .navbar-nav {
    width: 100% !important;
    justify-content: center;
    margin: auto;
    align-items: center;
    vertical-align: middle;
  }
  .arobtn {
    margin-top: 60px !important;
  }
}

@media (max-width: 962) {
  .logimg {
    display: none !important;
  }
}

@media (max-width: 768px) {
  .logoicon {
    display: block !important;
  }

  .cursorwidth {
    width: 100%;
  }
  .footerheight {
    height: 710px;
  }
  .bottomtext {
    margin-top: 80px;
  }
  .bottomtext span {
    font-size: 0.75rem;
  }
  .phonemode1 {
    display: none;
  }
  .phonemode2 {
    display: block;
  }
  .flogo {
    display: none;
  }
  .inner-text h4 {
    font-size: 1rem;
  }
  .inner-text p {
    font-size: 0.8rem;
  }
  .footertext {
    display: flex;
    justify-content: center;
    text-align: center;
    margin-top: 10px;
  }
  .sicons {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: -25px;
    padding: 0px 20px;
    margin-bottom: 20px;
  }
  .iconphone {
    display: block;
  }
  .oflogo {
    display: none;
  }
  .logimgphone {
    width: 100px !important;
    height: 80px !important;
    display: block;
    margin-left: 50px;
  }
  .arobtn {
    margin-top: 60px !important;
  }
  /* .navbar-nav {
    width: 100% !important;
    justify-content: center;
    margin: auto;
    align-items: center;
    vertical-align: middle;
  } */
  .socialicon {
    display: none !important;
  }

  .hometext {
    font-size: 2.5rem;
  }
  .hometext2 {
    font-size: 15px;
    width: 70%;
    margin: auto;
    margin-top: 600px;
  }
  .carousel-item img {
    width: 100%;
    height: 100%;
  }
  .carousel-item h1 {
    font-size: 1rem;
  }
  .heroimgbox p {
    font-size: 1rem;
  }
  .headerlogo {
    width: 100px;
    height: 80px;
  }
  .headerlogo:hover {
    width: 120px;
    height: 100px;
  }
  .mylogo {
    width: 150px !important;
    height: 80px !important;
  }
  .logimg:hover {
    width: 170px !important;
    height: 90px !important;
  }
  .nav-link {
    font-size: 12px;
  }
  .svgimg {
    width: 60px;
    height: 60px;
  }
  .svgimg:hover {
    width: 80px;
    height: 66px;
  }
  .headtext {
    font-size: 1rem;
  }
  .heroimgbox p {
    font-size: 1rem;
  }
  .hometext2 {
    font-size: 15px;
    width: 80%;
    margin: auto;
    margin-top: 600px;
  }
  .hometext {
    font-size: 2.5rem;
  }
  .hometext2 {
    font-size: 15px;
    width: 80%;
    margin: auto;
    margin-top: 600px;
  }
  .carousel-item img {
    width: 100%;
    height: 100%;
  }
  .carousel-item h1 {
    font-size: 1rem;
  }
  .heroimgbox p {
    font-size: 1rem;
  }
  .headerlogo {
    width: 100px;
    height: 80px;
  }
  .headerlogo:hover {
    width: 120px;
    height: 100px;
  }
  .mylogo {
    width: 150px !important;
    height: 80px !important;
  }
  .logimg:hover {
    width: 170px !important;
    height: 90px !important;
  }
  .nav-link {
    font-size: 12px;
  }
  .svgimg {
    width: 60px;
    height: 60px;
  }
  .svgimg:hover {
    width: 80px;
    height: 66px;
  }
  .headtext {
    font-size: 1rem;
  }
  .heroimgbox p {
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,8DAA8D;AAChE;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yDAAyC;EACzC,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,wDAAwD;EACxD,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE;2CAC2B;EAC3B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,WAAW;AACb;AACA;EACE,4CAA4C;EAC5C,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;AACA,iBAAiB;AACjB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,2BAA2B;EAC7B;EACA;;;;;;KAMG;EACH;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Roboto\", sans-serif;\n}\n\nbody {\n  overflow: visible !important;\n}\n\n.nav-link span:hover {\n  color: #e3b251 !important;\n  transition: all 0.3s ease;\n}\na {\n  text-decoration: none;\n}\n.mylogo {\n  width: 200px !important;\n  height: 100px !important;\n  z-index: 1;\n}\n.submit-btn {\n  font-family: inherit;\n}\n.submit-btn:hover {\n  color: #666666 !important;\n  transition: all 0.3s ease;\n}\n.form-group input::placeholder {\n  color: #bcb9b9 !important;\n}\n.form-group textarea::placeholder {\n  color: #cbc6c6 !important;\n}\n.logimg:hover {\n  width: 245px !important;\n  height: 135px !important;\n  z-index: 999 !important;\n}\n.nav-link {\n  font-size: 14px;\n  text-transform: capitalize;\n  transition: all 0.3s ease;\n}\n.logimg {\n  width: 200px !important;\n  height: 120px !important;\n  transition: all 0.3s ease;\n  z-index: 999 !important;\n}\n.carousel-indicators button {\n  color: gold !important;\n  background-color: linear-gradient(#bf953f, #fcf6ba) !important;\n}\n.navbar-nav {\n  align-items: center;\n  vertical-align: middle;\n}\n\n.nav-link {\n  margin-left: 20px;\n}\n\n.homeimge {\n  background-image: url(\"./asset/frot.jpg\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 140vh;\n  width: 100%;\n  position: relative;\n  padding-bottom: 60px;\n}\n.hometext {\n  color: #fff;\n  text-align: center;\n  font-size: 3.75rem;\n  font-weight: 700;\n  animation-duration: 1000ms;\n  top: 25%;\n  position: relative;\n}\n.hometext2 {\n  color: #fff;\n  text-align: center;\n  justify-content: center;\n  font-size: 20px;\n  width: 69%;\n  margin: auto;\n  margin-top: 760px;\n  display: flex;\n  flex-wrap: wrap;\n  word-break: normal;\n}\n.svgimg {\n  width: 80px;\n  height: 80px;\n  transition: all 0.3s ease-in-out;\n}\n.svgimg:hover {\n  width: 100px;\n  height: 86px;\n}\n\n.headtext {\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n.cimages h1 {\n  display: none;\n}\n\n.cimg {\n  width: 50%;\n  height: 40%;\n  margin: auto;\n  display: block;\n  transition: all 0.3s ease;\n}\n\n.cimg:hover {\n  width: 55%;\n}\n\n/* onhover imag h1 display: block;  */\n.cimages h1 {\n  display: none;\n  color: #fff;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: auto;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 85%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.cimages:hover h1 {\n  display: block;\n}\n.dimgtest p {\n  padding-top: 170px;\n}\n.dimgtest img {\n  padding-top: 100px;\n}\nli {\n  list-style-type: none;\n}\n.headerlogo {\n  width: 150px;\n  height: 100px;\n  transition: all 0.3s ease;\n}\n.headerlogo:hover {\n  width: 180px;\n  height: 120px;\n}\n.arobtn {\n  color: black !important;\n  font-size: 1.5rem;\n  background: linear-gradient(#bf953f, #fcf6ba) !important;\n  margin-top: 155px !important;\n  width: 50px !important;\n  height: 50px !important;\n  border-radius: 50% !important;\n  border: none !important;\n}\n\n.heroimgbox {\n  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),\n    url(\"./asset/imgs/3.jpg\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 100vh;\n  width: 100%;\n}\n.heroimgbox p {\n  font-family: \"Oswald\", sans-serif !important;\n  display: flex;\n  color: #fff;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: auto;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding-top: 250px;\n}\n\n.img-container .inner-box {\n  display: none;\n}\n.inner-text {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: start;\n  padding: 30px;\n}\n\n.img-container:hover .inner-box {\n  display: block;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #fff;\n  font-size: 1.2rem;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.headtest {\n  color: #fcf6ba;\n  font-family: \"Roboto Slab\", serif;\n  font-size: 3rem;\n  line-height: 1.1;\n  text-shadow: 2px 2px 8px rgba(128, 128, 128, 1);\n  font-weight: 700;\n  transition: all 1.25s ease;\n}\n\n.headtest:hover {\n  color: #fff;\n  font-size: 3.7rem;\n  transition: all 0.3s ease;\n}\n\n.logimgphone {\n  width: 100px !important;\n  height: 80px !important;\n  display: none;\n}\n.iconphone {\n  display: none !important;\n}\n.logoicon {\n  display: none !important;\n}\n.bottomtext {\n  margin-top: 100px;\n}\n.phonemode1 {\n  display: block;\n}\n\n.phonemode2 {\n  display: none;\n}\n.footerheight {\n  height: 400px;\n}\n\n.cursorwidth {\n  width: 75%;\n}\n/* media query  */\n@media (max-width: 1024px) {\n  .socialicon {\n    display: none !important;\n  }\n\n  .logimgphone {\n    width: 100px !important;\n    height: 80px !important;\n    display: block;\n  }\n  .logoicon {\n    display: block !important;\n  }\n  .navbar-nav {\n    width: 100% !important;\n    justify-content: center;\n    margin: auto;\n    align-items: center;\n    vertical-align: middle;\n  }\n  .arobtn {\n    margin-top: 60px !important;\n  }\n}\n\n@media (max-width: 962) {\n  .logimg {\n    display: none !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .logoicon {\n    display: block !important;\n  }\n\n  .cursorwidth {\n    width: 100%;\n  }\n  .footerheight {\n    height: 710px;\n  }\n  .bottomtext {\n    margin-top: 80px;\n  }\n  .bottomtext span {\n    font-size: 0.75rem;\n  }\n  .phonemode1 {\n    display: none;\n  }\n  .phonemode2 {\n    display: block;\n  }\n  .flogo {\n    display: none;\n  }\n  .inner-text h4 {\n    font-size: 1rem;\n  }\n  .inner-text p {\n    font-size: 0.8rem;\n  }\n  .footertext {\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    margin-top: 10px;\n  }\n  .sicons {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: -25px;\n    padding: 0px 20px;\n    margin-bottom: 20px;\n  }\n  .iconphone {\n    display: block;\n  }\n  .oflogo {\n    display: none;\n  }\n  .logimgphone {\n    width: 100px !important;\n    height: 80px !important;\n    display: block;\n    margin-left: 50px;\n  }\n  .arobtn {\n    margin-top: 60px !important;\n  }\n  /* .navbar-nav {\n    width: 100% !important;\n    justify-content: center;\n    margin: auto;\n    align-items: center;\n    vertical-align: middle;\n  } */\n  .socialicon {\n    display: none !important;\n  }\n\n  .hometext {\n    font-size: 2.5rem;\n  }\n  .hometext2 {\n    font-size: 15px;\n    width: 70%;\n    margin: auto;\n    margin-top: 600px;\n  }\n  .carousel-item img {\n    width: 100%;\n    height: 100%;\n  }\n  .carousel-item h1 {\n    font-size: 1rem;\n  }\n  .heroimgbox p {\n    font-size: 1rem;\n  }\n  .headerlogo {\n    width: 100px;\n    height: 80px;\n  }\n  .headerlogo:hover {\n    width: 120px;\n    height: 100px;\n  }\n  .mylogo {\n    width: 150px !important;\n    height: 80px !important;\n  }\n  .logimg:hover {\n    width: 170px !important;\n    height: 90px !important;\n  }\n  .nav-link {\n    font-size: 12px;\n  }\n  .svgimg {\n    width: 60px;\n    height: 60px;\n  }\n  .svgimg:hover {\n    width: 80px;\n    height: 66px;\n  }\n  .headtext {\n    font-size: 1rem;\n  }\n  .heroimgbox p {\n    font-size: 1rem;\n  }\n  .hometext2 {\n    font-size: 15px;\n    width: 80%;\n    margin: auto;\n    margin-top: 600px;\n  }\n  .hometext {\n    font-size: 2.5rem;\n  }\n  .hometext2 {\n    font-size: 15px;\n    width: 80%;\n    margin: auto;\n    margin-top: 600px;\n  }\n  .carousel-item img {\n    width: 100%;\n    height: 100%;\n  }\n  .carousel-item h1 {\n    font-size: 1rem;\n  }\n  .heroimgbox p {\n    font-size: 1rem;\n  }\n  .headerlogo {\n    width: 100px;\n    height: 80px;\n  }\n  .headerlogo:hover {\n    width: 120px;\n    height: 100px;\n  }\n  .mylogo {\n    width: 150px !important;\n    height: 80px !important;\n  }\n  .logimg:hover {\n    width: 170px !important;\n    height: 90px !important;\n  }\n  .nav-link {\n    font-size: 12px;\n  }\n  .svgimg {\n    width: 60px;\n    height: 60px;\n  }\n  .svgimg:hover {\n    width: 80px;\n    height: 66px;\n  }\n  .headtext {\n    font-size: 1rem;\n  }\n  .heroimgbox p {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
